<template>
  <div>
    <PCMenu :memberSystem="company" />
    <div class="main m-t-10">
      <div v-if="company.memberSystemId==116" class="w1200 m-auto flex m-b-50" >
        <div>
          <img src="@/assets/images/contact-back116.png"  style="width:300px;height:400px;margin-left:15px;">
        </div>
        <div class="buy m-l-20 fswy">
          <p style="font-weight: 700;color:#FF9900;font-size:30px;">联系我们：</p>

          <p style="margin-top:10px;"><b>深圳富士伟业科技有限公司</b></p>
          <p>地址：深圳市宝安区留仙二路三巷14号新政C栋1、3、5楼</p>
          <p>网站：www.foxwelltech.com.cn</p>
          <p>邮箱：cnsupport@foxwelltech.com</p>
          <p>电话：0755-26897226</p>
          <p>热线：400 900 6388</p>
          <img style="width:170px;height:180px;float: right;" src="@/assets/images/wechat-116.png"/>
        </div>
      </div>
      <div v-else class="w1200 m-auto flex m-t-10" style="align-items: center">
        <div >
          <img src="@/assets/images/product.jpg">
        </div>
        <div v-if="company && company.extendInfo && company.extendInfo.contact&&company.extendInfo.contact.qrcode" class="qrcode m-1l-200" style="flex:1;">
          <img :src="global.getStaticFilePath(company.extendInfo.contact.qrcode)">
          <div>扫码加客服或致电</div>
        </div>
        <div v-if="company && company.extendInfo && company.extendInfo.contact && company.extendInfo.contact.tel" class="contactus" style="flex:1;margin-top:-30px;text-align: center;">
          <h3>联系我们</h3>
          <p>
            <!-- 客服微信 ： daida-sh<br> -->
            客服专线： {{company.extendInfo.contact.tel}}
          </p>
        </div>
      </div>
    </div>
<!--    <PCCopyright />-->
  </div>
</template>

<script>
import PCMenu from "@/components/PCMenu.vue";
import PCCopyright from "@/components/PCCopyright.vue";

export default {
  name: "ContactUs",
  components: {
    PCMenu,
    PCCopyright,
  },
  data() {
    return {
      company:{}
    };
  },
  mounted() {
    this.global.getMemberSystem().then((memberSystem) => {
      if (!this.global.isNull(memberSystem)) {
        this.company = memberSystem;
      }
    });
  },
};
</script>


<style  lang="css" scoped>
.fswy{
  display: flex;flex-direction: column;
  align-items: flex-start;
  padding-right:30px;
  zoom:0.8;
}
.fswy p{
  font-size: 22px;padding:5px 0;
}
</style>
